"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestChatRequest =
/*#__PURE__*/
function (_pb_1$GuestChatReques) {
  _inherits(ExtendedGuestChatRequest, _pb_1$GuestChatReques);

  function ExtendedGuestChatRequest(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestChatRequest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestChatRequest).call(this, properties));
    _this.type = ExtendedGuestChatRequest.type;
    _this.chreqid = properties.proxy.chreqid;
    _this.bookingNo = properties.proxy.bookingNo;
    return _this;
  }

  _createClass(ExtendedGuestChatRequest, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.staff).concat(ExtendedGuestChatRequest.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestChatRequest.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestChatRequest(pb_1.GuestChatRequest.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestChatRequest;
}(pb_1.GuestChatRequest);

ExtendedGuestChatRequest.type = "GuestChatRequest";
ExtendedGuestChatRequest.context = "/guest-chat/request";
exports.GuestChatRequest = ExtendedGuestChatRequest;